import React, { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import Section from 'components/Section';
import FlightShortDetails from 'components/FlightShortDetails';
import OrderEditFlightTicket from 'components/OrderEditFlightTicket';

import { OrderEditMainTransport_order$key } from '__generated__/OrderEditMainTransport_order.graphql';

type Props = {
  order: OrderEditMainTransport_order$key;
};

const OrderEditMainTransport: FC<Props> = ({ order }) => {
  const orderData = useFragment(
    graphql`
      fragment OrderEditMainTransport_order on Order {
        flightBookingFailed
        flightBookingId
        flightBookingTransactionId

        flights {
          priceLive
          ...FlightShortDetails_flight
        }

        ...OrderEditFlightTicket_order
      }
    `,
    order
  );

  const {
    flights,
    flightBookingFailed,
    flightBookingId,
    flightBookingTransactionId,
  } = orderData;

  if (!flights) return null;

  return (
    <Section id="transport" title="Transportas">
      {flightBookingFailed && (
        <Alert severity="error" sx={{ mb: 2 }}>
          Nepavyko užsakyti skrydžio
        </Alert>
      )}

      <TableContainer sx={{ mb: 2 }}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Skrydis</TableCell>
              <TableCell align="right">Kaina</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell>
                <FlightShortDetails noLink flight={flights} />
              </TableCell>

              <TableCell align="right">€{flights.priceLive}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Grid container>
        <Grid item xs={6} sx={{ pr: 2 }}>
          <TextField
            fullWidth
            disabled
            label="Booking ID"
            variant="standard"
            value={flightBookingId}
          />
        </Grid>

        <Grid item xs={6} sx={{ pl: 2 }}>
          <TextField
            fullWidth
            disabled
            label="Transaction ID"
            variant="standard"
            value={flightBookingTransactionId}
          />
        </Grid>
      </Grid>

      <OrderEditFlightTicket order={orderData} />
    </Section>
  );
};

export default OrderEditMainTransport;
